import React, {useEffect, useState, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BodyContainer from '../bodyContainer/BodyContainer';
import ConfigurationToast from './configurationToast/ConfigurationToast';
import ReviewSubscriptionCard from './ReviewSubscriptionCard';
import { updateCompleteSubscription } from '../../../../redux/connectedComponent/completeSubscription/completeSubscription.slice';
import {AppSubscriptionsActivationTypes, AppSubscriptionsActivationStates } from '../../../subscription-successful/AppSubscriptionActivationTypeConstants';
import { withRouter } from 'react-router-dom';
import { Loader, IndeterminateProgressBar, LOADER_SIZE } from 'cdk-radial';
import Overlay from '../../../Overlay/Overlay';
import { setUrlParams } from '../../../../redux/connectedComponent/provisionSettings/provisionSettings.slice';
import { setScreen } from '../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../../config/uiFactory.config';
import { getSubscriptionId } from '../../../../redux/connectedComponent/completeSubscription/completeSubscription.slice';
import { addNavListener } from '../../../../utils/popstate';

const COLOR_STROKE = '#006CFA';

const CompleteConfiguration = (props) => {

  const [fetchSubscriptionIds, setFetchSubscriptionIds] = useState(false);
  const [urlParam, setURLParam] = useState(null);
  let [SUBSCRIPTION_ID_INTERVAL, setSUBSCRIPTION_ID_INTERVAL]= useState([]);
  let count = useRef(0);
  const [showErrorDialog, setShowErrorDialog] = useState(null);

  const dispatch = useDispatch();

  const solutionId =
    props.match && props.match.params && props.match.params.solutionId;
  const {
    loginDetailsSlice,
    selectDMSSlice,
    completeSubscriptionSlice,
    paymentCheckoutSlice,
    selectLocationsSlice,
    reviewSubscriptionSlice,
    solutionInfoSlice,
    provisionSettings,
    privacyProtectionSlice,
    apiFieldsSlice,
  } = useSelector(state => state);

  const selectedPlanId=solutionInfoSlice.selectedPlanId;
  const { subscriptionIds } = completeSubscriptionSlice;
  const { selectedLocationsWithCMFNumber }  = selectLocationsSlice;
  const token = loginDetailsSlice.authenticationToken;

  let planId ='';
  (selectedPlanId && selectedPlanId !== '') ? planId=selectedPlanId
    : planId=props.match && props.match.params && props.match.params.selectedPlanId;

  const redirectSuccess = provisionSettings.success;

  const {errorInSubscription, isSubscriptionComplete} = completeSubscriptionSlice || {};

  const {solutionInfo, constants} = solutionInfoSlice
  const {overview, provisioning_interface} = solutionInfo;
  let selectedLocationsEntityIds = provisioning_interface.entityID ?
  selectLocationsSlice.selectedLocationsWithCMFNumber &&
  selectLocationsSlice.selectedLocationsWithCMFNumber.length &&
  selectLocationsSlice.selectedLocationsWithCMFNumber.map(location => location.entityId) : [];

  let appSubscriptionActivationType = (solutionInfo && solutionInfo.app_subscriptions && solutionInfo.app_subscriptions.appSubscriptionsType) || AppSubscriptionsActivationTypes.AUTOMATIC;
  let appSubscriptionActivationState = (appSubscriptionActivationType === AppSubscriptionsActivationTypes.MANUAL) ? AppSubscriptionsActivationStates.PENDING : AppSubscriptionsActivationStates.ACTIVE;


  useEffect(() => {
    dispatch(
      updateCompleteSubscription({
        solutionId: solutionId,
        entityIdList: selectDMSSlice.selectedDMS && selectDMSSlice.selectedDMS.length > 0 ? selectDMSSlice.selectedDMS : (selectLocationsSlice.selectedLocationsWithCMFNumber),
        status: 'subscribe',
        token: loginDetailsSlice.authenticationToken,
        decodedToken:loginDetailsSlice.decodedToken,
        planId: solutionInfo.activateOnly === false ? planId : '',
        userEmail:loginDetailsSlice.userEmail,
        appName: overview.name,
        checkoutDetails: paymentCheckoutSlice.checkoutDetails ? paymentCheckoutSlice.checkoutDetails : null,
        address :  paymentCheckoutSlice.salesTaxRate ? paymentCheckoutSlice.salesTaxRate.address : null,
        tax :  paymentCheckoutSlice.salesTaxRate ? paymentCheckoutSlice.salesTaxRate.tax : null,
        checkoutType: paymentCheckoutSlice.checkoutType ? paymentCheckoutSlice.checkoutType : null,
        rShare: paymentCheckoutSlice.rShare ? paymentCheckoutSlice.rShare : null,
        userComment: reviewSubscriptionSlice.userComment ? reviewSubscriptionSlice.userComment : null,
        appSubscriptionActivationType,
        appSubscriptionActivationState,
        locations : selectLocationsSlice.selectedLocations,
        publisherName : overview.publisherName,
        firstName : loginDetailsSlice.decodedToken.firstName,
        publisherEmail : solutionInfo.subscription_notifications ? solutionInfo.subscription_notifications.email : "",
        paymentSetting:paymentCheckoutSlice.paymentSetting ? paymentCheckoutSlice.paymentSetting : null,
        emailsForSubscriptionNotifications: reviewSubscriptionSlice.emailsForSubscriptionNotifications ? reviewSubscriptionSlice.emailsForSubscriptionNotifications : [],
        activateOnly: solutionInfo.activateOnly === false ? false : true,
        privacyProtectionSupported: selectDMSSlice.privacyProtectionSupported,
        privacyProtectionOptOuts: privacyProtectionSlice.optOutsByLocation,
        selectedApiFields: apiFieldsSlice.selectedApiFields,
      })
    );
  }, []);

  useEffect(()=>{
    if(completeSubscriptionSlice.isSubscriptionComplete)
    {
      const {solutionInfo} = solutionInfoSlice
      if(solutionInfo.provisioning_interface.entityID){
        setURLParam(selectedLocationsEntityIds.join());
        dispatch(setUrlParams(selectedLocationsEntityIds.join()));
      } else {
        appSubscriptionActivationType === AppSubscriptionsActivationTypes.AUTOMATIC && setFetchSubscriptionIds(true);
      }
    }
  },[completeSubscriptionSlice.isSubscriptionComplete]);

  useEffect(()=>{
    if(fetchSubscriptionIds){
      if(subscriptionIds.length === selectedLocationsWithCMFNumber.length){
        SUBSCRIPTION_ID_INTERVAL.map(id => {
          clearInterval(id);
        });
        setFetchSubscriptionIds(false);
        setURLParam(subscriptionIds.join());
        dispatch(setUrlParams(subscriptionIds.join()));
      } else {
        const SUBSCRIPTION_ID_RETRY_INTERVAL = setInterval(() => {
          selectedLocationsWithCMFNumber.map(item => {
              dispatch(getSubscriptionId({
                  solutionId,
                  entityId: item.entityId,
                  location: item.location,
                  token
                }));
            })
            count.current = count.current + 1;
          },8000);

        let SUBSCRIPTION_INTERVALS = SUBSCRIPTION_ID_INTERVAL;
        SUBSCRIPTION_INTERVALS.push(SUBSCRIPTION_ID_RETRY_INTERVAL);
        setSUBSCRIPTION_ID_INTERVAL(SUBSCRIPTION_INTERVALS);
      }
    }
  },[fetchSubscriptionIds, subscriptionIds]);

  useEffect(() => {
    if(count.current > 9){
      SUBSCRIPTION_ID_INTERVAL.map(id => {
        clearInterval(id);
      });
      setShowErrorDialog(true);
      setFetchSubscriptionIds(false);
    }
  }, [count.current])

  useEffect(() => {
    if (redirectSuccess || showErrorDialog === false) {
      const currentUrl = window.location.href || '';
      let splitUrl = currentUrl.split('/dp/') || [];
      const newUrl = `${splitUrl[0]}/dp/management/${splitUrl[1]}`;
      window.history.pushState({ screen: screens.SUBSCRIPTION_MANAGEMENT }, "", newUrl);
      dispatch(setScreen({ screen: screens.SUBSCRIPTION_MANAGEMENT }));
      addNavListener(dispatch);
    }
  },[redirectSuccess, showErrorDialog]);

  const dialogContent = () => {
    if(fetchSubscriptionIds){
      return (
        <div className='dialog-fetch-ids'>
          This process usually takes 30-60 seconds to complete.
          <div className='fetch-subscriptionIds'>
            <IndeterminateProgressBar
              label={'Please wait...'}
              trackWidth={'370px'}
              loaderSize = {LOADER_SIZE.SMALL}
              />
          </div>
        </div>
      );
    } else if(showErrorDialog) {
      return (
        <div className='dialog-time-exceed'>
          {`This is taking more time than usual. Please configure your ${constants.ACTIVATION} from the App Management page with 'Configure App' menu, once it's activated.`}
        </div>
      );
    }
  }

  return (
    <div>
    <BodyContainer title={''} description={''}>
        {isSubscriptionComplete
         ? <div className='complete-configuration'>
          <div className='toast-container'>
            <ConfigurationToast urlParam={urlParam} redirectURL={provisioning_interface.redirectURL} entityID={provisioning_interface.entityID}/>
          </div>
          <div className='configure-summary-card-container'>
            <div className='configure-summary-card'>
              <div className="configure-summary-title">
                {constants.SUMMARY}
              </div>
              <div className='subscription-successful-card'>
                <ReviewSubscriptionCard />
              </div>
            </div>
          </div>
          {
            fetchSubscriptionIds
            ? <Overlay
              active={true}
              title={`Integrating Data & Completing ${constants.ACTIVATION} `}
              hideFirstButton={true}
              hideSecondButton={true}
              children={dialogContent()}
              hideCloseButton={true}
            />
            : null
          }
          {
            showErrorDialog
              ? <Overlay
                active={true}
                title={`Integrating Data & Completing ${constants.ACTIVATION}`}
                hideFirstButton={true}
                hideSecondButton={true}
                children={dialogContent()}
                hideCloseButton={false}
                onOverlayClose={()=>setShowErrorDialog(false)}
              />
              : null
          }
        </div>
        : <div className='load-configuration'><Loader style={{ stroke: COLOR_STROKE }} /></div>
        }
    </BodyContainer>
    </div>
  );
}

export default withRouter(CompleteConfiguration);
